import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdatePhysicalDockActions as Actions,
  UpdatePhysicalDockRequestAction as RequestAction,
} from 'store/ducks/physicalDocks';

export function* updatePhysicalDockRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `docks-physical/${id}`, putData);
    const shouldCommit = onSuccess?.();
    if (shouldCommit === false) return;
    notify('success', 'Doca física atualizada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    const shouldCommit = onFailure?.();
    if (shouldCommit === false) return;
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
